import ListRfqQuotesAsList from '../../../../../../client/src/rfq/src/viewmodel/ListRfqQuotesAsListViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';

export default class DesListRfqQuotesAsList extends DesBaseCollabAcc {

    constructor() {
        console.log('DesListRfqQuotesAsList invoked');
        super(ListRfqQuotesAsList);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id' ];
    }
}
if (!window.customElements.get('des-list-rfq-quotes-as-list')) {
    window.customElements.define('des-list-rfq-quotes-as-list', DesListRfqQuotesAsList);
}
